import script from "./MainNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./MainNavbar.vue?vue&type=script&setup=true&lang=js"

import "./MainNavbar.vue?vue&type=style&index=0&id=12831962&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12831962"]])

export default __exports__